/* eslint no-underscore-dangle: 0 */
import { LAYER_SUCCESS } from 'actionTypes';

// Records which modal if any to show on exit intent
const initialState = null;

export default function(state = initialState, action) {
  switch (action.type) {
    case LAYER_SUCCESS: {
      if (action.payload.layerId !== 'exitIntent') {
        return state;
      }
      return action.payload.modal;
    }
    default: {
      return state;
    }
  }
}
